/**
 * Router 모듈
 * @module app/Routers
 * @author Olive
 */
import { createBrowserRouter, Navigate, Outlet } from 'react-router';

import LoginPage from '@/pages/app/login/Login';
import AuthCallbackPage from '@/pages/app/login/AuthCallbackPage';
import MainPage from '@/pages/app/main/MainPage';
import useAppAuthStore from '@/shared/store/UseAppAuthStore';
import AdventurePage from '@/pages/app/adventure/AdventurePage';
import AppPage from '@/pages/app/AppPage';
import Achievements from '@/pages/app/mypage/Achievements';
import MyPage from '@/pages/app/mypage/MyPage';
import Quiz from '@/pages/app/adventure/Quiz';
import Record from '@/pages/app/record/Record';
import Book from '@/pages/app/book/Book';
import BookPerson from '@/pages/app/book/BookPerson';
import ChapterIntro from '@/pages/app/adventure/Chapter';
import Sources from '@/pages/app/mypage/Sources';
import FAQ from '@/pages/app/mypage/FAQ';
import Settings from '@/pages/app/mypage/Settings';
import CharacterChange from '@/pages/app/mypage/Character';
import Level from '@/pages/app/mypage/Level';
import StreakLearning from '@/pages/app/event/StreakLearning';

// 보호된 레이아웃
const ProtectedLayout = () => {
  const accessToken = useAppAuthStore.getState().accessToken;
  if (!accessToken) return <Navigate to="/login" replace />;
  return <AppPage />;
};

const Routers = createBrowserRouter(
  [
    {
      path: '/',
      children: [
        // ===== Public Routes (인증 불필요) =====
        { path: 'login', Component: LoginPage },
        // { path: 'intro', Component: IntroPage },
        { path: 'auth/callback', Component: AuthCallbackPage },

        // ===== Protected Routes (인증 필요) =====
        {
          element: <ProtectedLayout />,
          children: [
            { index: true, element: <Navigate to="/main" replace /> },
            { path: 'main', Component: MainPage },

            // Adventure 관련
            { path: 'adventure', Component: AdventurePage },
            { path: 'adventure/chapter', Component: ChapterIntro },
            { path: 'adventure/quiz', Component: Quiz },

            // MyPage 관련
            { path: 'mypage', Component: MyPage },
            { path: 'mypage/faq', Component: FAQ },
            { path: 'mypage/settings', Component: Settings },
            { path: 'mypage/sources', Component: Sources },
            { path: 'mypage/character', Component: CharacterChange },
            { path: 'mypage/level', Component: Level },
            { path: 'mypage/achievements', Component: Achievements },

            // 기록
            { path: 'record', Component: Record },

            // 이벤트
            { path: 'event/streak', Component: StreakLearning },

            // Book 관련
            { path: 'book', Component: Book },
            { path: 'book/person', Component: BookPerson },
          ],
        },
      ],
    },
  ],
  { basename: '/' },
);

export default Routers;
